import React, { createContext, useContext, useState } from "react";

const LoadingContext = createContext(
  undefined
);

export const useLoading = () => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error("useLoading must be used within a LoadingProvider");
  }
  return context;
};
 
export const LoadingProvider = ({ children }) => {
  const [isLoading, setLoading] = useState(false);

  const contextValue = {
    isLoading,
    setLoading,
  };

  return (
    <LoadingContext.Provider value={contextValue}>
      {children}
    </LoadingContext.Provider>
  );
};
